import { useEffect, useRef } from "react";
import dynamic from "next/dynamic";
import DreamforceAnnouncementBar from "./DreamforceAnnouncementBar";
// import DreamforceMeetingModal from "@/common/modals/DreamforceMeetingModal";
import { useDreamforceCampaign } from "@/hooks/useDreamforceCampaign";

const DreamforceMeetingModal = dynamic(
  () => import("@/common/modals/DreamforceMeetingModal"),
  { ssr: false },
);

const DreamforceCampaign: React.FC = () => {
  const barRef = useRef<HTMLDivElement>(null);
  // const { showBanner, showPopup, closeBanner, closePopup, openPopupNow } =
  //   useDreamforceCampaign();
  const { showBanner, closeBanner, openPopupNow } =
    useDreamforceCampaign();
  useEffect(() => {
    const root = document.documentElement;

    if (!showBanner) {
      root.style.setProperty("--df-banner-offset", "0px");
      return;
    }

    const el = barRef.current;
    if (!el) return;

    const updateOffset = () =>
      root.style.setProperty("--df-banner-offset", `${el.offsetHeight}px`);

    updateOffset();
    const observer = new ResizeObserver(updateOffset);
    observer.observe(el);

    return () => {
      observer.disconnect();
      root.style.setProperty("--df-banner-offset", "0px");
    };
  }, [showBanner]);

  return (
    <>
      <DreamforceAnnouncementBar
        ref={barRef}
        show={showBanner}
        onClose={closeBanner}
        onMeetUsClick={openPopupNow}
      />
      {/* Dreamforce meeting popup temporarily disabled */}
      {/* <DreamforceMeetingModal show={showPopup} handleClose={closePopup} /> */}
    </>
  );
};

export default DreamforceCampaign;
